<script>
/** A standardized way to do external links */

import Vue       from 'vue';
import Component from 'vue-class-component';

@Component({
	props : {
		href  : String,
		shown : Boolean,
	},
})
export default class ExternalLink extends Vue {}
</script>

<template>
<a
	:href  = "href"
	target = "_blank"
	rel    = "external nofollow noopener"
>
	<slot></slot> <FontAwesomeIcon v-if="shown" class="fa-xs" icon="fas fa-external-link" />
</a>
</template>
